// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-datepicker-calendar {
  flex: 1 1 auto;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/common/Datepicker/Calendar/Calendar.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,gBAAA;AACJ","sourcesContent":[".dl-datepicker-calendar {\n  flex: 1 1 auto;\n  overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
